import ReducerRegistry from "seneca-common/utils/state/reducer-registry";

import { PREMIUM_TRIALS_STATE_SLICE_PATH } from "./consts";
import premiumTrialStateSliceReducer from "./reducers/state";

const reducerRegistry = ReducerRegistry.getInstance();
reducerRegistry.initialise(PREMIUM_TRIALS_STATE_SLICE_PATH, builder => {
  builder.register(
    PREMIUM_TRIALS_STATE_SLICE_PATH,
    premiumTrialStateSliceReducer
  );
});

export { PREMIUM_TRIALS_STATE_SLICE_PATH, premiumTrialStateSliceReducer };

// models

export type { PremiumTrialsResponse } from "./models/PremiumTrialsResponse";

//selectors

export {
  canStudyWrongAnswersSession,
  getTrialsState,
  getWrongAnswersSessionsInitiallyGranted,
  getWrongAnswersSessionsRemaining,
  hasWrongAnswersPremiumTrial,
  trialIsUpdating,
  trialUpdateErrored,
  trialUpdateSucceeded, // meta
  trialsAreFetching,
  trialsFetchErrored,
  trialsFetchFinished,
  trialsFetchSucceeded,
  trialsNeedFetching,
  userHasFinishedWrongAnswersTrial,
  wrongAnswersTrialIsUpdating,
  wrongAnswersTrialUpdateErrored,
  wrongAnswersTrialUpdateSucceeded
} from "./selectors";

// actions

export { receivePremiumTrials } from "./actions";
export {
  fetchTrialsActionFactory,
  updateTrialActionFactory // This can be remove when we implement an event-based back-end
} from "./actions/meta";
